// Size Guide Tabs Functionality
// This enables tab switching for the size guide modal
// and is compatible with the markup in main-product.liquid

document.addEventListener('DOMContentLoaded', function () {
  const sizeGuideModal = document.querySelector('.size-guide-modal');

  if (sizeGuideModal) {
    const tabList = sizeGuideModal.querySelector('.size-guide-tab-list');
    const tabButtons = sizeGuideModal.querySelectorAll('.size-guide-tab');
    const tabPanels = sizeGuideModal.querySelectorAll('.size-guide-tab-panel');

    if (!tabList || tabButtons.length === 0 || tabPanels.length === 0) return;

    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active/selected from all tabs and panels
        tabButtons.forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(panel => {
          panel.classList.remove('active');
          panel.setAttribute('hidden', 'hidden');
        });

        // Activate the clicked tab and corresponding panel
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        const panelId = this.getAttribute('aria-controls') || this.getAttribute('id').replace('tab', 'panel');
        const panel = document.getElementById(panelId);

        if (panel) {
          panel.classList.add('active');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  const unitToggle = sizeGuideModal ? sizeGuideModal.querySelector('input[id^="unitToggle-"]') : null;
  const sizeGuideGroups = sizeGuideModal ? sizeGuideModal.querySelectorAll('.size-guide-group') : [];

  // Show CM by default and toggle all groups together
  for (const group of sizeGuideGroups) {
    const cmTable = group.querySelector('.cm-table');
    const inTable = group.querySelector('.in-table');
    if (cmTable) cmTable.style.display = 'table';
    if (inTable) inTable.style.display = 'none';
  }

  if (unitToggle) {
    unitToggle.addEventListener('change', function() {
      for (const group of sizeGuideGroups) {
        const cmTable = group.querySelector('.cm-table');
        const inTable = group.querySelector('.in-table');

        if (this.checked) {
          if (cmTable) cmTable.style.display = 'none';
          if (inTable) inTable.style.display = 'table';
        } else {
          if (cmTable) cmTable.style.display = 'table';
          if (inTable) inTable.style.display = 'none';
        }
      }
    });
  }

  // Fix accessibility issues in merchant-authored page content
  // 1. Remove empty headings (e.g. <h3><br></h3>) that produce "empty heading" violations
  document.querySelectorAll('.size-guide-group h1, .size-guide-group h2, .size-guide-group h3, .size-guide-group h4').forEach(heading => {
    if (heading.textContent.trim() === '') heading.remove();
  });

  // 2. Fix empty <th> corner cells in size tables — add scope + visually-hidden text
  document.querySelectorAll('.size-guide-group table th').forEach(th => {
    if (th.textContent.trim() === '') {
      th.setAttribute('scope', 'col');
      th.innerHTML = '<span class="visually-hidden">Size</span>';
    } else if (!th.hasAttribute('scope')) {
      th.setAttribute('scope', 'col');
    }
  });

  const videoContainers = document.querySelectorAll('.size-guide-tab-panel-video');

  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const poster = container.querySelector('.poster-image');
    const playBtn = container.querySelector('.play-btn');
    const pauseBtn = container.querySelector('.pause-btn');

    // Initial state: show poster and play button
    container.classList.remove('playing');
    video.pause();
    video.currentTime = 0;

    // Play button click
    playBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      container.classList.add('playing');
      video.play();
    });

    // Pause button click
    pauseBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      video.pause();
      container.classList.remove('playing');
    });

    // When video ends, reset to initial state
    video.addEventListener('ended', function() {
      container.classList.remove('playing');
      video.currentTime = 0;
    });

    // Optional: clicking poster also plays video
    if (poster) {
      poster.addEventListener('click', function(e) {
        e.stopPropagation();
        container.classList.add('playing');
        video.play();
      });
    }
  });
});

